/**
 * Uygulayıcı paneli.
 *
 * Yönlendirme için kütüphane kullanılmıyor: ekran sayısı az ve hepsi
 * oturum gerektiriyor. Adres çubuğunda danışan kimliği taşımak da
 * istemiyoruz — paylaşılan bir ekran görüntüsünde ya da tarayıcı
 * geçmişinde danışan kimliğinin durması gereksiz bir sızıntı.
 */

import { useCallback, useEffect, useState } from 'react'
import { api, ROL_ADI, type Kullanici } from './api'
import { Giris } from './pages/Giris'
import { Danisanlar } from './pages/Danisanlar'
import { Danisan } from './pages/Danisan'
import { Rapor } from './pages/Rapor'
import { RaporDuzenle } from './pages/RaporDuzenle'
import { OdevDetayi } from './pages/OdevDetayi'
import { ProgramOlustur } from './pages/ProgramOlustur'
import { OdevAta } from './pages/OdevAta'
import { Ekip } from './pages/Ekip'
import { Ogretmenler } from './pages/Ogretmenler'
import { Kayitlar } from './pages/Kayitlar'
import { Takvim } from './pages/Takvim'
import { SeansNotu } from './pages/SeansNotu'
import { Paketler } from './pages/Paketler'
import { Hesap } from './pages/Hesap'
import { Belgeler } from './pages/Belgeler'

type Ekran =
  | { ad: 'danisanlar' }
  | { ad: 'danisan'; id: string }
  | { ad: 'rapor'; olcumId: string; geriDanisanId?: string }
  | { ad: 'raporTaslagi'; raporId: string; geriDanisanId: string }
  | { ad: 'odev'; odevId: string; geriDanisanId: string }
  | { ad: 'program'; danisanId: string }
  | { ad: 'odevAta'; danisanId: string }
  | { ad: 'seans'; seansId: string; geriDanisanId: string }
  | { ad: 'hesap'; danisanId: string }
  | { ad: 'belgeler'; danisanId: string }
  | { ad: 'paketler' }
  | { ad: 'takvim' }
  | { ad: 'ekip' }
  | { ad: 'ogretmenler' }
  | { ad: 'kayitlar' }

export function App() {
  const [kullanici, setKullanici] = useState<Kullanici | null>(null)
  const [yukleniyor, setYukleniyor] = useState(true)
  const [ekran, setEkran] = useState<Ekran>({ ad: 'danisanlar' })

  useEffect(() => {
    api
      .ben()
      .then((r) => setKullanici(r.kullanici))
      .catch(() => setKullanici(null))
      .finally(() => setYukleniyor(false))
  }, [])

  const cikis = useCallback(async () => {
    await api.cikis().catch(() => undefined)
    setKullanici(null)
    setEkran({ ad: 'danisanlar' })
  }, [])

  if (yukleniyor) {
    return (
      <div className="icerik">
        <p className="alt">Yükleniyor…</p>
      </div>
    )
  }

  if (!kullanici) return <Giris onGiris={setKullanici} />

  const yetkili = kullanici.rol === 'owner' || kullanici.rol === 'practitioner'

  return (
    <div className="kabuk">
      <header className="ust">
        <span className="marka">Nirengi</span>
        <nav>
          <button
            className={ekran.ad === 'danisanlar' || ekran.ad === 'danisan' ? 'aktif' : ''}
            onClick={() => setEkran({ ad: 'danisanlar' })}
          >
            Danışanlar
          </button>
          <button
            className={ekran.ad === 'takvim' ? 'aktif' : ''}
            onClick={() => setEkran({ ad: 'takvim' })}
          >
            Takvim
          </button>
          <button
            className={ekran.ad === 'paketler' ? 'aktif' : ''}
            onClick={() => setEkran({ ad: 'paketler' })}
          >
            Paketler
          </button>
          <button
            className={ekran.ad === 'ogretmenler' ? 'aktif' : ''}
            onClick={() => setEkran({ ad: 'ogretmenler' })}
          >
            Okul
          </button>
          {yetkili && (
            <button
              className={ekran.ad === 'ekip' ? 'aktif' : ''}
              onClick={() => setEkran({ ad: 'ekip' })}
            >
              Ekip
            </button>
          )}
          {/*
            Sekreter de görüyor: gönderilemeyen hatırlatmanın peşine
            düşecek olan o. Hangi sekmeyi açabildiğini bileşen kendi
            belirliyor, asıl kural sunucuda.
          */}
          {(yetkili || kullanici.rol === 'assistant') && (
            <button
              className={ekran.ad === 'kayitlar' ? 'aktif' : ''}
              onClick={() => setEkran({ ad: 'kayitlar' })}
            >
              Kayıtlar
            </button>
          )}
        </nav>
        <div className="sag">
          <span>
            {kullanici.unvan ? kullanici.unvan + ' ' : ''}
            {kullanici.adSoyad} · {ROL_ADI[kullanici.rol] ?? kullanici.rol}
          </span>
          <button onClick={() => void cikis()}>Çıkış</button>
        </div>
      </header>

      <main className="icerik">
        {ekran.ad === 'danisanlar' && (
          <Danisanlar onAc={(id) => setEkran({ ad: 'danisan', id })} yazabilir={yetkili} />
        )}
        {ekran.ad === 'danisan' && (
          <Danisan
            id={ekran.id}
            yazabilir={yetkili}
            onGeri={() => setEkran({ ad: 'danisanlar' })}
            onRapor={(olcumId) => setEkran({ ad: 'rapor', olcumId, geriDanisanId: ekran.id })}
            onRaporTaslagi={(raporId) =>
              setEkran({ ad: 'raporTaslagi', raporId, geriDanisanId: ekran.id })
            }
            onOdev={(odevId) => setEkran({ ad: 'odev', odevId, geriDanisanId: ekran.id })}
            onProgram={() => setEkran({ ad: 'program', danisanId: ekran.id })}
            onOdevAta={() => setEkran({ ad: 'odevAta', danisanId: ekran.id })}
            onSeans={(seansId) => setEkran({ ad: 'seans', seansId, geriDanisanId: ekran.id })}
            onHesap={() => setEkran({ ad: 'hesap', danisanId: ekran.id })}
          />
        )}
        {ekran.ad === 'raporTaslagi' && (
          <RaporDuzenle
            raporId={ekran.raporId}
            onGeri={() => setEkran({ ad: 'danisan', id: ekran.geriDanisanId })}
          />
        )}
        {ekran.ad === 'rapor' && (
          <Rapor
            olcumId={ekran.olcumId}
            onGeri={() =>
              ekran.geriDanisanId
                ? setEkran({ ad: 'danisan', id: ekran.geriDanisanId })
                : setEkran({ ad: 'danisanlar' })
            }
          />
        )}
        {ekran.ad === 'odev' && (
          <OdevDetayi
            odevId={ekran.odevId}
            yazabilir={yetkili}
            onGeri={() => setEkran({ ad: 'danisan', id: ekran.geriDanisanId })}
          />
        )}
        {ekran.ad === 'program' && (
          <ProgramOlustur
            danisanId={ekran.danisanId}
            onBitti={() => setEkran({ ad: 'danisan', id: ekran.danisanId })}
            onIptal={() => setEkran({ ad: 'danisan', id: ekran.danisanId })}
          />
        )}
        {ekran.ad === 'odevAta' && (
          <OdevAta
            danisanId={ekran.danisanId}
            onBitti={() => setEkran({ ad: 'danisan', id: ekran.danisanId })}
            onIptal={() => setEkran({ ad: 'danisan', id: ekran.danisanId })}
          />
        )}
        {ekran.ad === 'seans' && (
          <SeansNotu
            seansId={ekran.seansId}
            onGeri={() => setEkran({ ad: 'danisan', id: ekran.geriDanisanId })}
          />
        )}
        {ekran.ad === 'hesap' && (
          <Hesap
            danisanId={ekran.danisanId}
            yazabilir={yetkili || kullanici.rol === 'assistant'}
            onGeri={() => setEkran({ ad: 'danisan', id: ekran.danisanId })}
            onBelgeler={() => setEkran({ ad: 'belgeler', danisanId: ekran.danisanId })}
          />
        )}
        {ekran.ad === 'belgeler' && (
          <Belgeler
            danisanId={ekran.danisanId}
            danisanAdi=""
            yazabilir={yetkili || kullanici.rol === 'assistant'}
            onGeri={() => setEkran({ ad: 'hesap', danisanId: ekran.danisanId })}
          />
        )}
        {ekran.ad === 'paketler' && <Paketler yazabilir={yetkili} />}
        {ekran.ad === 'takvim' && (
          <Takvim
            yazabilir={yetkili || kullanici.rol === 'assistant'}
            onDanisan={(id) => setEkran({ ad: 'danisan', id })}
          />
        )}
        {ekran.ad === 'ogretmenler' && (
          <Ogretmenler
            yazabilir={yetkili}
            onDanisan={(id) => setEkran({ ad: 'danisan', id })}
          />
        )}
        {ekran.ad === 'ekip' && <Ekip rol={kullanici.rol} />}
        {ekran.ad === 'kayitlar' && <Kayitlar rol={kullanici.rol} />}
      </main>
    </div>
  )
}
